import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import Index from "./pages/Index";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Premium from "./pages/Premium";
import NotFound from "./pages/NotFound";
import SecurityTools from "./pages/SecurityTools";
import Moderation from "./pages/Moderation";
import AiFeatures from "./pages/AiFeatures";
import Engagement from "./pages/Engagement";
import FAQ from "./pages/FAQ";
import Support from "./pages/Support";
import Features from "./pages/Features";
import Imprint from "./pages/Imprint";
import Checkout from "./pages/Checkout";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Career from "./pages/Career";
import OpenPositions from "./pages/OpenPositions";
import Promotions from "./pages/Promotions";
import Sell from "./pages/Sell";
import Donate from "./pages/Donate";
import Network from "./pages/Network";
import Travel from "./pages/Travel";
import Italy from "./pages/Italy";
import Dashboard from "./pages/Dashboard";
import ServerDetails from "./pages/ServerDetails";
import Info from "./pages/Info";
import { useState, useEffect } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const queryClient = new QueryClient();

const App = () => {
  const [showShutdownDialog, setShowShutdownDialog] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("shutdownDialogSeen")) {
      setShowShutdownDialog(true);
    }
  }, []);

  const handleDialogClose = () => {
    localStorage.setItem("shutdownDialogSeen", "true");
    setShowShutdownDialog(false);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system">
        <TooltipProvider>
          <Toaster />
          <Sonner />
            <AlertDialog open={showShutdownDialog}>
            <AlertDialogContent>
              <AlertDialogHeader>
              <AlertDialogTitle>Important information</AlertDialogTitle>
              <AlertDialogDescription>
                This service will be discontinued on the 22.06.2025. Thank you for using Fembot!
              </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
              <AlertDialogAction onClick={handleDialogClose} autoFocus>
                Understood
              </AlertDialogAction>
                <AlertDialogAction
                  onClick={() => {
                  handleDialogClose();
                  window.location.href = "/info";
                  }}
                  style={{ backgroundColor: "#2e3fa3", color: "#fff" }}
                >
                  Learn More
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
            </AlertDialog>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/premium" element={<Premium />} />
              <Route path="/security-tools" element={<SecurityTools />} />
              <Route path="/moderation" element={<Moderation />} />
              <Route path="/ai-features" element={<AiFeatures />} />
              <Route path="/engagement" element={<Engagement />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/support" element={<Support />} />
              <Route path="/features" element={<Features />} />
              <Route path="/imprint" element={<Imprint />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/careers" element={<Career />} />
              <Route path="/open-positions" element={<OpenPositions />} />
              <Route path="/promotions" element={<Promotions />} />
              <Route path="/sell" element={<Sell />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/network" element={<Network />} />
              <Route path="/travel" element={<Travel />} />
              <Route path="/italy" element={<Italy />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/server/:serverId" element={<ServerDetails />} />
              <Route path="/info" element={<Info />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
